module.exports = __webpack_public_path__ + "img/banner.6f6988f8.jpg";